import { ReactNode } from 'react';

const controlHintIds = (
  id: string,
  labelHint?: ReactNode,
  hint?: string,
  errorMessage?: string,
  characterCountMax?: number,
  ariaDescribedBy?: string,
): {
  labelHintId?: string;
  hintId?: string;
  errorId?: string;
  characterCountId?: string;
  describedBy?: string;
} => {
  const labelHintId = labelHint ? `${id}-label-hint` : undefined;
  const hintId = hint ? `${id}-hint` : undefined;
  const characterCountId = characterCountMax !== undefined ? `${id}-character-count` : undefined;
  const errorId = errorMessage ? `${id}-error` : undefined;
  const describedBy = [ariaDescribedBy, hintId, errorId, characterCountId].filter(Boolean).join(' ') || undefined;

  return {
    labelHintId,
    hintId,
    errorId,
    characterCountId,
    describedBy,
  };
};

export default controlHintIds;
